module.exports = __webpack_public_path__ + "static/media/post-mobile.edc9b7f2.svg";